import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'shared/hooks';

import { loadOffersThunk, statusSelector } from '../store';

interface UseLoadOffersArgs {
    pageNumber?: number;
}

export function useLoadOffers(args?: UseLoadOffersArgs) {
    const { pageNumber } = args || {};
    const dispatch = useAppDispatch();
    const status = useSelector(statusSelector);

    useEffect(function dispatchLoadOffersThunk() {
        if (status !== 'idle') {
            return;
        }

        dispatch(loadOffersThunk({ pageNumber }));
    }, [ dispatch, status, pageNumber ]);
}
